// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Apply pink color filter to map tiles */
.leaflet-tile-pane {
  filter: hue-rotate(300deg) saturate(1.2) brightness(1.1);
}

/* Make sure our custom elements aren't affected by the filter */
.leaflet-overlay-pane,
.leaflet-marker-pane,
.leaflet-tooltip-pane,
.leaflet-popup-pane {
  filter: none;
}

/* Reposition Mapbox controls to be below the header */
.mapboxgl-ctrl-top-left {
  top: 70px !important; /* Position controls below the header and force override */
  z-index: 9999; /* Ensures controls are clickable and on top of other elements */
}

/* Hide Mapbox logo */
.mapboxgl-ctrl-logo {
  display: none !important;
}

`, "",{"version":3,"sources":["webpack://./src/components/MapStyles.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;EACE,wDAAwD;AAC1D;;AAEA,gEAAgE;AAChE;;;;EAIE,YAAY;AACd;;AAEA,sDAAsD;AACtD;EACE,oBAAoB,EAAE,0DAA0D;EAChF,aAAa,EAAE,gEAAgE;AACjF;;AAEA,qBAAqB;AACrB;EACE,wBAAwB;AAC1B","sourcesContent":["/* Apply pink color filter to map tiles */\n.leaflet-tile-pane {\n  filter: hue-rotate(300deg) saturate(1.2) brightness(1.1);\n}\n\n/* Make sure our custom elements aren't affected by the filter */\n.leaflet-overlay-pane,\n.leaflet-marker-pane,\n.leaflet-tooltip-pane,\n.leaflet-popup-pane {\n  filter: none;\n}\n\n/* Reposition Mapbox controls to be below the header */\n.mapboxgl-ctrl-top-left {\n  top: 70px !important; /* Position controls below the header and force override */\n  z-index: 9999; /* Ensures controls are clickable and on top of other elements */\n}\n\n/* Hide Mapbox logo */\n.mapboxgl-ctrl-logo {\n  display: none !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
